import { render, staticRenderFns } from "./AddRejectOrderComment.vue?vue&type=template&id=18ea9d5a&scoped=true&"
import script from "./AddRejectOrderComment.vue?vue&type=script&lang=js&"
export * from "./AddRejectOrderComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ea9d5a",
  null
  
)

export default component.exports